<template>
  <v-footer app inset color="transparent" absolute height="56" class="px-0">
    <div class="boxed-container w-full">
      <div class="mx-6 d-flex justify-space-between">
        <span>
          &copy; {{ new Date().getFullYear() }}
          <a :href="footerUrl" class="text-decoration-none" target="_blank">{{ footerText }}</a></span
        >
      </div>
    </div>
  </v-footer>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  setup(props, { root }) {
    const brand = computed(() => root.$store.getters.brand);
    const footerText = computed(() => brand.value?.footerText || "Promptcruise.com");
    const footerUrl = computed(() => brand.value?.footerUrl || "https://promptcruise.com");

    return {
      footerText,
      footerUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>
